import React from 'react';
import Icon from '../../icons/Icon';
import VerifiedContent from '../../../content/VerifiedContent';

const VerifiedDetails = () => {
    const renderItems = () => {
        const iconDefaultSize = '45px';
        const style = { backgroundColor: '#DBF3F5', fill: '#4BC1CA' };

        const itemsRendered = [];
        for (let i = 0; i < VerifiedContent.length; i++) {
            itemsRendered.push(
                <div
                    className="app__grid__column__one-one app__verified-details__table-cell"
                    key={i}>
                    <div className="app__verified-details__icon">
                        <Icon icon={VerifiedContent[i].icon} size={iconDefaultSize} style={style} />
                    </div>
                    <div
                        className="app__verified-details__info font-lighter"
                        dangerouslySetInnerHTML={{ __html: VerifiedContent[i].text }}></div>
                </div>
            );
        }

        return itemsRendered;
    };

    return (
        <div className="app__landing-page__section verified-details">
            <div className="verified-details__container">
                <h5 className="vouchedfor-brand">Verified advisers</h5>
                <div className="under-title"></div>

                <div className="push-up-30 push-down-20 font-lighter">
                    We will only connect you to an adviser who is...
                </div>

                <div className="app__verified-details">
                    <div className="app__verified-details__list">{renderItems()}</div>
                </div>
            </div>
        </div>
    );
};

export default VerifiedDetails;
